<div class="form-group">
  <div class="row align-items-center">
    <div class="col-lg d-flex">
      <h3 class="h5 fw-normal">Phone Number</h3>
      <span class="d-md-none">
        <i class="add-circle-icon ms-1 text-primary" (click)="enableAddPhone()"></i>
      </span>
    </div>
    <div class="col-lg text-end d-none d-md-block">
      <div>
        <button class="btn btn-primary" (click)="enableAddPhone()">Add</button>
      </div>
    </div>
  </div>
  <ul class="list-group mt-3">
    @if (!dataLoaded()) {
      <li class="list-group-item">
        <!-- //NOSONAR -->
        <ngx-skeleton-loader count="1" [theme]="{ height: '5rem' }"></ngx-skeleton-loader>
      </li>
    } @else if (!addPhoneMode() && dataLoaded()) {
      @if (phoneNumbers().length === 0 && !addPhoneMode()) {
        <li class="list-group-item">
          <!-- //NOSONAR -->
          <p class="h6 fw-normal m-1 py-3">There are no phone numbers on file for this educator</p>
        </li>
      }
      @for (number of phoneNumbers(); track number) {
        <li class="list-group-item clickable" (click)="loadEditForm(number)" [ngClass]="phoneNumberItemClasses(number)">
          <!-- //NOSONAR -->
          @if (!!number) {
            <div class="d-flex justify-content-between my-1">
              <div>
                <span class="h6 fw-normal me-2">{{ number.phoneNumber | phoneNumber }}</span>
                <span class="badge-md badge-info me-2">{{ number.description }}</span>
                @if (number.isMobile == true) {
                  <span class="badge-md badge-light me-2">Mobile</span>
                }
              </div>
              @if (number.personPhoneNumberId != selectedPhoneNumber()?.personPhoneNumberId) {
                <div>
                  <i certTooltip="Edit" class="edit-icon-lg"></i>
                </div>
              }
            </div>
          }
        </li>
      }
    } @else if (addPhoneMode() && dataLoaded()) {
      <li class="list-group-item">
        <!-- //NOSONAR -->
        <edportal-educator-contact-phone-form
          #phoneForm
          [phoneNumber]="selectedPhoneNumber()"
          [phoneOptions]="phoneOptions()"
          (phoneChanged)="handleFormEvent($event)"
        ></edportal-educator-contact-phone-form>
      </li>
    }
  </ul>
</div>
